import './main.styles.scss';

function Main({ children, className }: { children: React.ReactElement; className?: string }): React.ReactElement {
  return <main className={className}>{children}</main>;
}

export default Main;
